// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getDeathInfoFromElit, SaveICACorrectness, CheckApplicantAddress } from '@api';
import moment from 'moment';

export const getDeathInfo = createAsyncThunk('verification/getDeathInfo', async args => {
  const response = await getDeathInfoFromElit(args);
  return response.data;
})

export const saveCorrectness = createAsyncThunk('verification/save_ica', async args => {
  const response = await SaveICACorrectness(args);
  return response.data;
})

export const checkApplicantAddress = createAsyncThunk('caveat_ica/check_applicant_address', async args => {
  console.log("helloooo");
  const response = await CheckApplicantAddress();
  return response.data;
})

export const verificationSlice = createSlice({
  name: 'verification',
  initialState: {
    status: 'none',
    erroMessage: '',
    principalName: "",
    deathGender: "",
    deathDate: "",
    person: { nalty: "" },
    validApplicantAddress: false,

  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getDeathInfo.fulfilled, (state, action) => {
        state.status = action.payload.status;
        state.message = action.payload.erroMessage || "";
        state.principalName = action.payload.principalName || "";
        state.deathGender = (action.payload.deathGender === "M" ? "male" :
          (action.payload.deathGender === "F" ? "female" : "others")) || "";
        state.deathDate = moment(action.payload.deathDate).format('DD/MM/yyy') || "";
        state.person = action.payload.person;
      })
      .addCase(checkApplicantAddress.fulfilled, (state, action) =>{
        state.validApplicantAddress = action.payload.applicantAddressValid
      })

  }

})

//export const {} = eligibilityCheckSlice.actions

export default verificationSlice.reducer

